import script from "./ProgAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgAgreement.vue?vue&type=script&setup=true&lang=js"

import "./ProgAgreement.vue?vue&type=style&index=0&id=af5f567e&lang=scss"

const __exports__ = script;

export default __exports__